module.exports = __webpack_public_path__ + "static/4-Roof-view-with-landscape-podium-75706347fe5f80b443a810f2c34efea9.jpg";